export enum authType {
  OTP = "OTP",
  PIN = "PIN",
}

export enum authHeaders {
  Authorization = "Authorization",
}
